import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotSeries from './components/HotSeries';
import LatestUpdates from './components/LatestUpdates';
import CategoryGrid from './components/CategoryGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotSeries />
        <LatestUpdates />
        <CategoryGrid />
        <Testimonials />
        <CTASection />

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "韩漫网",
          "url": "http://mostlive.cn/",
          "description": "韩漫网是您的免费韩漫在线阅读平台，提供高清下拉式全集漫画大全，画质清晰阅读流畅，打造影院级观看体验。",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "http://mostlive.cn/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "韩漫网",
          "url": "http://mostlive.cn/",
          "description": "韩漫网是领先的免费韩漫在线阅读平台，致力于为广大漫画爱好者提供高清下拉式全集韩漫资源。",
          "email": "hello@mostlive.cn",
          "sameAs": [
            "http://mostlive.cn/",
            "http://mostlive.cn/user/hanmanwang"
          ]
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://mostlive.cn/" }
          ]
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "韩漫网 - 免费韩漫在线阅读平台 | 高清下拉式韩漫全集",
          "description": "韩漫网是您的免费韩漫在线阅读平台，提供高清下拉式全集漫画大全。收录海量热门韩国漫画，画质清晰阅读流畅，打造影院级观看体验。",
          "url": "http://mostlive.cn/"
        }) }} />
      </main>
      <Footer />
    </>
  );
}